import { render } from "./AssignedLeads.vue?vue&type=template&id=6afd6446"
import script from "./AssignedLeads.vue?vue&type=script&lang=js"
export * from "./AssignedLeads.vue?vue&type=script&lang=js"
script.render = render

export default script